import { Injectable } from '@angular/core';
import { Division } from '@app/modules/auth/models/core-company-api.model';

@Injectable({
  providedIn: 'root'
})
export class DivisionCacheService {
  constructor() {}
  divisions: Division[];
}
